import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useLastPunch } from '../hooks/useWebclock';
import { styled } from '@mui/material/styles';

export default function Footer({ onMissPunchClick = () => {} }) {
  const { hasLastPunch, lastPunchDate, lastPunchType, lastPunchTime } =
    useLastPunch();

  return (
    <>
      <Stack gap={1} alignItems="center" sx={{ pt: 6, pb: 4, width: '100%' }}>
        <>
          <LastPunch>
            {hasLastPunch ? (
              <>
                Last Punch: {lastPunchDate && `${lastPunchDate} `}
                <span>{lastPunchType}</span> at {lastPunchTime}
              </>
            ) : (
              'No Recent Punch'
            )}
          </LastPunch>
          <MissPunchButton
            id="sc-miss_last_punch_button"
            variant="text"
            onClick={onMissPunchClick}
          >
            Miss your last Punch?
          </MissPunchButton>
        </>
      </Stack>
    </>
  );
}

Footer.propTypes = {
  onMissPunchClick: PropTypes.func,
};

// ####################
// ### Styled ###
// ####################

const LastPunch = styled(
  (props) => <Typography variant="body2" color="text.primary" {...props} />,
  {
    shouldForwardProp: (prop) => prop !== 'hasLastPunch',
  }
)(({ theme }) => ({
  '& span': {
    fontWeight: theme.typography.fontWeightBold,
  },
}));

const MissPunchButton = styled((props) => <Button variant="text" {...props} />)(
  {
    '&:hover': {
      opacity: 0.8,
    },
  }
);
